export enum ElementKind {
  Product = 'product',
  Element = 'element',
  Version = 'version',
  ProjectFolder = 'project-folder',
  ProjectInfo = 'project-info',
  ProductCategory = 'product-category',
  ProductGroup = 'product-group',
  ProductItem = 'product-item',
}
export const elementKinds = Object.values(ElementKind);
